import { OwcChip } from "@one/react";
const CustomChip = ({ text, ...props }) => <OwcChip {...props}>{text}</OwcChip>;

export default CustomChip;
